import dom from '../../../wrapper/DomWrapper';

import errorHandler from './errorHandler';
import pictureErrorHandler from './pictureErrorHandler';

const slideBgErrorHandler = () => {
  const selectorName = '.slide_bg ._error-wrap';
  const onError = (elImage, elParent) => {
    pictureErrorHandler(elImage, elParent, () => {
      dom.addClass(elParent, 'picture-wrap_unavailable');
    });
  };

  errorHandler(selectorName, onError);
};

export default slideBgErrorHandler;
